// extracted by mini-css-extract-plugin
module.exports = {"container":"DeleteSpecialCategory_container__O-naw","m_bottom_1":"DeleteSpecialCategory_m_bottom_1__3zkWF","actions_button":"DeleteSpecialCategory_actions_button__M0MYr"};